/**
 * Copyright (c) 2023-present,
 * Eunoia Digital, S.L. All rights reserved.
 */

import { AxiosError, AxiosResponse } from 'axios';
import configuration from 'config';
import OnboardingPerfilDeConsumo from 'types/models/onboardingPertfilConsumo';
import apiService from './ApiService';

export class OnboardingPerfilDeConsumoService {
  private readonly http = apiService;

  private apiUrl = configuration.apiUrl;

  public async getAllPerfilesDeConsumo(): Promise<Array<OnboardingPerfilDeConsumo>> {
    const url = `${this.apiUrl}/onboarding/perfiles-de-consumo/`;

    const response: AxiosResponse = await this.http.get(url);
    const configuraciones = new OnboardingPerfilDeConsumo().deserializeArray(response.data);
    return configuraciones;
  }

  public async getPerfilesDeConsumorById(id: Number): Promise<OnboardingPerfilDeConsumo> {
    const url = `${this.apiUrl}/onboarding/perfiles-de-consumo/${id}`;

    const response: AxiosResponse = await this.http.get(url);

    return new OnboardingPerfilDeConsumo().deserialize(response.data);
  }

  async patchCsvCurvaDeConsumo(id: string, file: File): Promise<any> {
    const url = `${this.apiUrl}/onboarding/perfiles-de-consumo/${id}/subir-curva/`;
    const csvData = new window.FormData();
    csvData.append('curvaDeConsumo', file);

    let responsePromise;
    try {
      const response: AxiosResponse = await this.http.put(url, csvData);
      responsePromise = response.status;
    } catch (error: unknown) {
      if ((error as AxiosError)?.response?.data && (error as AxiosError).response?.status === 400) {
        responsePromise = {
          codigo: (error as AxiosError).response?.data[0].codigo,
          mensaje: (error as AxiosError).response?.data[0].mensaje,
        };
      }
    }
    return responsePromise;
  }
}

const OnboardingPerfilDeConsumoInstance = new OnboardingPerfilDeConsumoService();
export default OnboardingPerfilDeConsumoInstance;
